import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getOrdersDelivery = async (params) => {
	const { data } = await axios.get(`${API}/client/orders_delivery`, {
		params,
	});
	return data;
};

export const getCreate = async (params) => {
	const { data } = await axios.get(`${API}/client/orders_delivery/data_orders`, {
		params,
	});
	return data;
};

export const validateExistenceOrderDelivery = async (order_delivery_id, dealer_id, delivery_number) => {
	const newParams = {
		order_delivery_id,
		delivery_number,
		dealer_id,
	};
	const { data } = await axios.get(`${API}/client/orders_delivery/validate_existence`, {
		params: newParams,
	});
	return data;
};

export const saveOrderDelivery = async ({ params, base }) => {
	const { data } = await axios.post(`${API}/client/orders_delivery/save`, {
		...base,
		params,
	});
	return data;
};

export const deleteOrderDelivery = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders_delivery/delete`, {
		...base,
		element,
	});
	return data;
};

export const assignOrderDelivery = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders_delivery/assign_confirm`, {
		...base,
		element,
	});
	return data;
};

export const transformOrderDelivery = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/orders_delivery/transform`, {
		...base,
		element,
	});
	return data;
};
